import React, { useEffect, useState } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'react-simple-snackbar';
import { createContact, updateContact } from '../../actions/contactActions';
import useAuthUser from '../../hooks/useAuthUser';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: '#1976D2',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const defaultState = { name: '', role: '', email: '', phone: '', locationId: '', accountId: '', primary: false, userId: [] }

const inputStyle = {
  display: "block",
  padding: "1.1rem 0.75rem",
  width: "100%",
  fontSize: "0.9rem",
  lineHeight: 1.25,
  color: "#55595c",
  backgroundColor: "#fff",
  backgroundImage: "none",
  backgroundClip: "padding-box",
  borderTop: "0",
  borderRight: "0",
  borderBottom: "1px solid #eee",
  borderLeft: "0",
  borderRadius: "3px",
  transition: "all 0.25s cubic-bezier(0.4, 0, 1, 1)"
}

const AddContact = ({ setOpen, open, currentId, setCurrentId, defaultAccountId, defaultLocationId }) => {
  const authData = useAuthUser()
  const dispatch = useDispatch()
  const contact = useSelector((state) => currentId ? state.contacts.contacts.find((c) => c._id === currentId) : null)
  const accounts = useSelector((state) => state.accounts.accounts || [])
  const locations = useSelector((state) => state.locations.locations || [])
  const [contactData, setContactData] = useState(defaultState)
  // eslint-disable-next-line
  const [openSnackbar, closeSnackbar] = useSnackbar()

  useEffect(() => {
    if (contact) {
      setContactData(contact)
    }
  }, [contact])

  useEffect(() => {
    if (open && !currentId) {
      setContactData((prev) => ({
        ...defaultState,
        userId: prev.userId,
        accountId: defaultAccountId || '',
        locationId: defaultLocationId || '',
      }))
    }
  }, [open, currentId, defaultAccountId, defaultLocationId])

  useEffect(() => {
    const userId = authData?.result?._id || authData?.result?.googleId
    if (userId) {
      setContactData((prev) => ({ ...prev, userId: [userId] }))
    }
  }, [authData])

  const clear = () => {
    setCurrentId(null)
    setContactData(defaultState)
  }

  const handleClose = () => {
    setOpen(false);
    clear();
  };

  const handleSubmit = (e) => {
    e.preventDefault()
    if (currentId) {
      dispatch(updateContact(currentId, contactData, openSnackbar))
    } else {
      dispatch(createContact(contactData, openSnackbar))
    }
    handleClose()
  }

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} fullWidth>
      <DialogTitle id="customized-dialog-title" onClose={handleClose} style={{ paddingLeft: '20px', color: 'white' }}>
        {currentId ? 'Edit Contact' : 'Add Contact'}
      </DialogTitle>
      <DialogContent dividers>
        <div className="customInputs">
          <input
            placeholder="Name"
            style={inputStyle}
            name='name'
            type='text'
            onChange={(e) => setContactData({ ...contactData, name: e.target.value })}
            value={contactData.name}
          />
          <input
            placeholder="Role"
            style={inputStyle}
            name='role'
            type='text'
            onChange={(e) => setContactData({ ...contactData, role: e.target.value })}
            value={contactData.role}
          />
          <input
            placeholder="Email"
            style={inputStyle}
            name='email'
            type='email'
            onChange={(e) => setContactData({ ...contactData, email: e.target.value })}
            value={contactData.email}
          />
          <input
            placeholder="Phone"
            style={inputStyle}
            name='phone'
            type='text'
            onChange={(e) => setContactData({ ...contactData, phone: e.target.value })}
            value={contactData.phone}
          />
          <select
            style={inputStyle}
            name='accountId'
            onChange={(e) => setContactData({ ...contactData, accountId: e.target.value })}
            value={contactData.accountId || ''}
          >
            <option value="">Account (optional)</option>
            {accounts.map((a) => (
              <option key={a._id} value={a._id}>{a.name}</option>
            ))}
          </select>
          <select
            style={inputStyle}
            name='locationId'
            onChange={(e) => setContactData({ ...contactData, locationId: e.target.value })}
            value={contactData.locationId || ''}
          >
            <option value="">Location (optional)</option>
            {locations.map((l) => (
              <option key={l._id} value={l._id}>{l.name}</option>
            ))}
          </select>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
            <input
              type="checkbox"
              checked={Boolean(contactData.primary)}
              onChange={(e) => setContactData({ ...contactData, primary: e.target.checked })}
              style={{ width: 18, height: 18 }}
            />
            Primary Contact
          </label>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit} variant="contained" color="primary" style={{ marginRight: '16px' }}>
          Save Contact
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddContact
